import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useEffect, useState } from 'react';
import { getLocation } from '../utils/geoLocation';
import { sendClickStreamViewEvent, sendEventToRio } from '../utils/analytics';
import { CANADA_COUNTRY_CODE, QUEBEC_REGION } from '../constants';
import { siteMapper } from '../selectors';
import { CheggEnv } from '@chegg/utils';
export var useRegionValidation = function useRegionValidation(_ref) {
  var countryCode = _ref.countryCode,
    region = _ref.region,
    environment = _ref.environment,
    siteName = _ref.siteName;
  var _useState = useState(environment !== CheggEnv.PROD ? countryCode : ''),
    _useState2 = _slicedToArray(_useState, 2),
    paymentCountryCode = _useState2[0],
    setPaymentCountryCode = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isRegionBlocked = _useState4[0],
    setIsRegionBlocked = _useState4[1];
  var _useState5 = useState(true),
    _useState6 = _slicedToArray(_useState5, 2),
    regionLoadInProgress = _useState6[0],
    setRegionLoadInProgress = _useState6[1];
  var updateRegion = function updateRegion(region) {
    if (region === QUEBEC_REGION) {
      setIsRegionBlocked(true);
      sendEventToRio(sendClickStreamViewEvent({
        view_name: 'restrict free trial modal',
        experience: siteMapper(siteName),
        property: 'wt'
      }));
    }
    setRegionLoadInProgress(false);
  };
  useEffect(function () {
    var locationHandler = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var location, country, region;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getLocation(environment);
            case 2:
              location = _context.sent;
              country = location.countryCode || 'US';
              region = location.region || '';
              setPaymentCountryCode(country);
              updateRegion(region);
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function locationHandler() {
        return _ref2.apply(this, arguments);
      };
    }();
    if (region && paymentCountryCode === CANADA_COUNTRY_CODE) {
      updateRegion(region);
    } else if (!paymentCountryCode) {
      void locationHandler();
    } else if (paymentCountryCode && regionLoadInProgress) {
      setRegionLoadInProgress(false);
    }
  }, []);
  return {
    countryCode: paymentCountryCode,
    isRegionBlocked: isRegionBlocked && siteName !== 'citethisforme',
    regionLoadInProgress: regionLoadInProgress
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/dist/esm/hooks/useRegionValidation.js
// module id = 2873
// module chunks = 11